/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Layout_Open_SidebarInputs */

const en_admin_company_layout_open_sidebar = /** @type {(inputs: Admin_Company_Layout_Open_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open sidebar`)
};

const de_admin_company_layout_open_sidebar = /** @type {(inputs: Admin_Company_Layout_Open_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenleiste öffnen`)
};

/**
* | output |
* | --- |
* | "Open sidebar" |
*
* @param {Admin_Company_Layout_Open_SidebarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_layout_open_sidebar = /** @type {((inputs?: Admin_Company_Layout_Open_SidebarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Layout_Open_SidebarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_layout_open_sidebar(inputs)
	return en_admin_company_layout_open_sidebar(inputs)
});